/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddMemberToTeamPlannerRequest } from '../../models/add-member-to-team-planner-request';

export interface AddMemberToTeamPlanner$Params {
  id: string;
      body: AddMemberToTeamPlannerRequest
}

export function addMemberToTeamPlanner(http: HttpClient, rootUrl: string, params: AddMemberToTeamPlanner$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addMemberToTeamPlanner.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addMemberToTeamPlanner.PATH = '/v0/teamPlanners/{id}/add-member';
